import React from "react";
import { ShieldCheck } from "lucide-react";

export function ComplianceBanner({ text, className = "" }) {
  return (
    <div
      className={`flex gap-3 p-5 rounded-xl bg-white/[0.03] border border-white/10 ${className}`}
      data-testid="compliance-banner"
    >
      <ShieldCheck size={18} className="text-health shrink-0 mt-0.5" />
      <p className="text-xs text-white/50 leading-relaxed">{text}</p>
    </div>
  );
}

export default ComplianceBanner;
